import { useEffect, useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import { LurkerAccess, LurkerApiService } from '../services/LurkerApiService';

const NO_ACCESS: LurkerAccess = { owner: false };

/**
 * What the signed-in user may do in Lurker; no owner rights until the server says so for this
 * sign-in, or when it cannot be asked. The server refuses an owner's writes from anyone else either
 * way. `checked` says the server answered, or failed to, for this sign-in.
 */
export function useLurkerAccess(): LurkerAccess & { checked: boolean } {
  const { token } = useAuthContext();
  // The answer is kept with the token it was asked with, so a new sign-in starts without rights.
  const [answer, setAnswer] = useState<{ token: string; access: LurkerAccess } | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    LurkerApiService.fetchAccess(token, controller.signal)
      .then((access) => setAnswer({ token, access }))
      .catch(() => !controller.signal.aborted && setAnswer({ token, access: NO_ACCESS }));
    return () => controller.abort();
  }, [token]);
  const checked = answer !== null && answer.token === token;
  return { ...(checked ? answer.access : NO_ACCESS), checked };
}
